import { defineMessages } from "react-intl";

export const checklistReviewValueText = defineMessages({
  assignedTo: {
    defaultMessage: "Assigned to: {value}",
    id: "vL+q0J",
  },
  dueDate: {
    defaultMessage: "Due date: {value}",
    id: "8lXYAc",
  },
  no: {
    defaultMessage: "No",
    id: "oUWADl",
  },
  yes: {
    defaultMessage: "Yes",
    id: "a5msuh",
  },
});
